/**
 * Directions for ordering
 */
export enum OrderByDirection
{
    /**
     * Items are ordered ascending
     */
    Ascending,
    
    /**
     * Items are ordered descending
     */
    Descending
}